export default __webpack_public_path__ + "static/media/saveMony.6fac3991.png";